import { Radio } from "antd-mobile";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import "./style.scss";

const NoMoreReminder = ({ checked, setChecked }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.radioContainer} radio-container`}>
      <Radio checked={checked} onClick={() => setChecked(!checked)}>
        {t("dailyCheck.noMore.reminder")}
      </Radio>
    </div>
  );
};

export default NoMoreReminder;
